import actionTypes from '../../action-types'

export default (payload, included) => ({
  type: actionTypes.CUSTOMERS.SET,
  payload,
  included,
})
